import queryString from 'query-string'

type GetUrlOptions = {
  base?: string
  query?: any
}

type GetRawUrl = <T>(urls: T) => (path: keyof T, base?: string) => string

export const getRawUrl: GetRawUrl =
  urls =>
  (path, base = '/') =>
    base + urls[path]

type GetUrl = <T>(urls: T) => (path: keyof T, params?: any, options?: GetUrlOptions) => string

export const getUrl: GetUrl =
  urls =>
  (path, params = {}, { base, query } = {}) => {
    const url = Object.keys(params).reduce(
      (str, key) => str.replace(`:${key}?`, params[key]).replace(`:${key}`, params[key]),
      getRawUrl(urls)(path, base),
    )

    return query ? `${url}?${queryString.stringify(query)}` : url
  }
